import { render } from "./Svgicon.vue?vue&type=template&id=5ddde668"
import script from "./Svgicon.vue?vue&type=script&lang=js"
export * from "./Svgicon.vue?vue&type=script&lang=js"

import "./Svgicon.vue?vue&type=style&index=0&id=5ddde668&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__